import isNil from 'lodash/isNil'
import * as Redux from 'redux'
import uuid from 'uuid'
import * as Sortable from '../../../components/sortable'
import * as Request from '../../../request'
import * as Schedules from '../constants'
import * as Constants from './constants'
import * as Types from './types'

interface IndexableHoliday extends Types.Holiday {
  rowIndex: number
}
const rowIndexById = (state: Types.Holidays, id: number): number => {
  return  state.map((h: Types.Holiday, rowIndex: number) => ({...h, rowIndex}))
               .filter((x: IndexableHoliday) => x.id === id)
               .map((x: IndexableHoliday) => x.rowIndex)[0]
}

interface DeleteAction {
  id: number
}

interface UpdateAction {
  id: number,
  field: string,
  value: any,
}

type AllActions = Redux.Action & DeleteAction & UpdateAction & Sortable.SortAction & Request.SuccessAction

const emptyHolidayState: Types.HolidayDataState = {
  data: [],
  initialData: [],
  isEditing: false,
  isSaving: false,
}
const holidaysReducer = (state: Types.HolidayDataState, action: AllActions):
  Types.HolidayDataState => {
  const rowIndex = isNil(action.id) ? -1 : rowIndexById(state.data, action.id)
  switch (action.type) {
    case Request.successConstant(Schedules.FETCH_SCHEDULES):
    case Request.successConstant(Constants.UPDATE_HOLIDAYS):
      const sorted: Types.Holiday[] =
        Sortable.sortState(action.payload.response.holidays, [{field: 'holiday', dir: 'desc'}])
      return {
        data: sorted,
        initialData: sorted,
        isEditing: false,
        isSaving: false,
      }
    case Request.errorConstant(Schedules.FETCH_SCHEDULES):
    case Request.errorConstant(Constants.UPDATE_HOLIDAYS):
      return {
        ...state,
        isSaving: false,
      }
    case Constants.SAVE_HOLIDAYS:
      return {
        ...state,
        isSaving: true,
      }
    case Constants.RESET_HOLIDAYS:
      return {
        ...state,
        data: state.initialData,
        isEditing: false,
      }
    case Constants.UPDATE_HOLIDAY_FIELD:
      return {
        ...state,
        data: [
          ...state.data.slice(0, rowIndex),
          {
            ...state.data[rowIndex],
            [action.field]: action.value,
            is_updated: true,
          },
          ...state.data.slice(rowIndex + 1),
        ],
        isEditing: true,
      }
    case Constants.DELETE_HOLIDAY:
      return {
        ...state,
        data: [
          ...state.data.slice(0, rowIndex),
          {
            ...state.data[rowIndex],
            [action.field]: action.value,
            is_active: false,
            is_updated: true,
            },
          ...state.data.slice(rowIndex + 1),
        ],
        isEditing: true,
      }
    case Constants.ADD_HOLIDAY:
      return {
        ...state,
        data: [
          ...state.data,
          {
            holiday: '',
            id: uuid(),
            is_active: true,
            is_synthetic: true,
            is_updated: true,
            name: '',
          },
        ],
        isEditing: true,
      }
    case Sortable.sortTableConstant(Constants.SORT_HOLIDAYS):
      return {
        ...state,
        data: Sortable.sortState(state.data, action.options.value),
      }
    default:
      return state || emptyHolidayState
  }
}

const reducerEvent: Sortable.ReducerEvent<Types.Holiday> = {
  requestEvent: Schedules.FETCH_SCHEDULES,
  sortEvent: Constants.SORT_HOLIDAYS,
}

export const reducer = Redux.combineReducers({
  state: holidaysReducer,
  view: Sortable.viewReducer(reducerEvent),
})



// WEBPACK FOOTER //
// ./src/pages/schedules/holidays/reducer.ts